import i18next from "i18next";
import client from "src/api/client";
import type { ComplianceUserActionHandler } from "src/components/UserActions/Handlers/Compliance/types";

const DOCUMENT_COMPLIANCE_OVERRIDE_ENTRY_KEY = "documentComplianceOverride";
const DOCUMENT_REJECTION_REASON_ENTRY_KEY = "rejectionReasonKey";
const DOCUMENT_REJECTION_REASON_ENTRY = "rejectionReason";
const REJECT_DOCUMENT_COMPLIANCE_ENTRY_VALUE = "REJECT";

const handleForceReject: ComplianceUserActionHandler = async (
  documentDetails,
  metadata
) => {
  const attributes: Record<string, string> = {
    [DOCUMENT_COMPLIANCE_OVERRIDE_ENTRY_KEY]:
      REJECT_DOCUMENT_COMPLIANCE_ENTRY_VALUE,
  };
  if (metadata) {
    attributes[DOCUMENT_REJECTION_REASON_ENTRY_KEY] =
      metadata[DOCUMENT_REJECTION_REASON_ENTRY_KEY];
    attributes[DOCUMENT_REJECTION_REASON_ENTRY] = i18next.t(
      metadata[DOCUMENT_REJECTION_REASON_ENTRY_KEY],
      { lng: "en" }
    );
  }
  const { overriddenMetadataIndexStarted } =
    await client.saveOverriddenMetadata({
      documentType: documentDetails.documentType,
      documentId: documentDetails.documentId,
      countryCode: documentDetails.countryCode,
      attributes,
      shouldRestartComplianceProcess: true,
    });

  return overriddenMetadataIndexStarted;
};

export default handleForceReject;
